<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  watch: {
    '$route': {
      handler(val) {
        // Document.title
        document.title = this.$t('APP.TITLE');
        if (val.name) {
          document.title += ' - ' + this.$t(val.name);
        }
      },
      deep: true
    },
  }
}
</script>

<style>
.text-field-bgr .v-input__slot {
  box-shadow: inset 0 2px 4px -2px rgba(0,0,0,0.3) !important;
  background-color: #b3dcffa1 !important;
}
.text-field-bgr.v-input--is-disabled .v-input__slot {
  opacity: .6;
}

.tab-header {
	box-shadow: none;
  box-shadow: 0px 1px 7px -3px rgba(0, 0, 0, 0.7);
  background: radial-gradient(ellipse at center bottom, rgb(255, 255, 255) 30%, rgba(179, 220, 255, 0) 70%);
}

.page-content {
  background: rgba(0, 0, 0, 0) radial-gradient(circle at center top, rgb(250, 252, 253) 40%, rgba(179, 220, 255, 0.63) 100%) repeat scroll 0% 0%;
  background: radial-gradient(circle at center top, rgb(240, 247, 251) 40%, rgba(179, 220, 255, 0.6) 100%);
}

.line-short,
.line-height-1,
.line-height-100 {
  line-height: 1em !important;
}
.line-height-110 {
  line-height: 1.1em !important;
}
.line-height-120 {
  line-height: 1.2em !important;
}
</style>
